export default __webpack_public_path__ + "static/media/polyester.3f052724.png";